import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 32px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const Card = styled.div`
  padding: 24px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 16px;
  box-shadow: 0 0.125rem 0.375rem 0 rgb(161 172 184 / 12%);

  & + & {
    margin-top: 16px;
  }
`;
